export function calculateAreaProperties(area: number) {
    const isAreaSmall = area <= 2;
    const treshold = isAreaSmall ? 0.75 : Number((area * 0.03).toFixed(2));
    const maxArea = area + treshold;
    const minArea = area - treshold;

    return { isAreaSmall, treshold, maxArea, minArea };
}
